import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/kac-yasinda-botoks-yapmaliyim-botoksa-baslama-yasi-rehberi/page.tsx");
